import type { Components } from '@/api/generated/api';
import { defineStore } from 'pinia';

export interface ICurrentClassState {
  currentClass: Components.Schemas.SchoolClassDto | null;
}

export const useCurrentClassStore = defineStore('currentClass', {
  actions: {
    setCurrentClass(currentClass: Components.Schemas.SchoolClassDto | null): void {
      this.$patch((state) => {
        state.currentClass = currentClass;
      });
    },
    updateCurrentClass(currentClass: Components.Schemas.SchoolClassDto | null): void {
      if (this.currentClass == null || currentClass?.id !== this.currentClass.id) return;
      this.$patch((state) => {
        state.currentClass = { ...this.currentClass, ...currentClass };
      });
    },
  },

  state: (): ICurrentClassState => ({
    currentClass: null,
  }),

  persist: true,
});
